const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function defaultDateFormat(d: Date): string {
  const month = months[d.getUTCMonth()];
  const day = d.getUTCDate();
  const year = d.getUTCFullYear();
  return month + " " + day + ", " + year;
}

export function timeAgoDateFormat(d: Date): string {
  const now = new Date();
  const span = (Number(now) - Number(d)) / 1000;
  if (span < 60) {
    return "Just now";
  } else if (span < 60 * 60) {
    const minutes = Math.floor(span / 60);
    const label = minutes === 1 ? "minute" : "minutes";
    return minutes + " " + label + " ago";
  } else if (span < 60 * 60 * 24) {
    const hours = Math.floor(span / (60 * 60));
    const label = hours === 1 ? "hour" : "hours";
    return hours + " " + label + " ago";
  } else {
    const opts = { year: 'numeric', month: 'short', day: 'numeric' };
    return d.toLocaleString(undefined, opts);
  }
}

export function dateFromString(s: string): Date {
  let clean_s = s.replace(/\+(.*)/, "Z");
  clean_s = clean_s.replace(" ", "T");
  return new Date(clean_s);
}

export function apiStringFromDate(d: Date): string {
  return d.toISOString();
}